module.exports = __webpack_public_path__ + "media/images/logos/simrad-cta-317f29ed9c03a258237e345035f82fb7.jpg";